
export class LoginInfoModel {
    organizationid: string;
    organizationname: string;
    companyid: string;
    custid: string;
}